import {PAYOUT_PURPOSE_CODES_BY_AUTHORITY, PayoutCreditorKind} from '@sollapay/enums';

import {isAuthorityPayeeKind} from './creditor-account.utils';

import type {PayeeKind} from './creditor-account.utils';
import type {PayoutPurposeCode} from '@sollapay/enums';
import type {PayoutCreditorDTO} from '@sollapay/types';
import type {TFunction} from 'i18next';

/** Tax Authority's list deliberately has no OTHER — its extractor's enum is closed with no fallback. */
export function getPurposeCodeOptions(payeeKind: PayeeKind): PayoutPurposeCode[] {
  if (!isAuthorityPayeeKind(payeeKind)) return [];
  return [...PAYOUT_PURPOSE_CODES_BY_AUTHORITY[payeeKind]];
}

/** An OTHER purpose carries its own free-text detail; every other code translates through the shared catalog. */
export function resolvePurposeLabel(
  params: {purposeCode: string; purposeOtherDetail: string | null},
  t: TFunction<'trustAccounts'>
): string {
  return (
    params.purposeOtherDetail ?? t(`view.payouts.create.details.purposeCode.${params.purposeCode}`)
  );
}

/** A beneficiary's purpose is free text (`description`); an authority's is its purpose code, or the free-text detail when that code is OTHER. */
export function resolvePayoutDescription(
  creditor: PayoutCreditorDTO,
  t: TFunction<'trustAccounts'>
): string {
  return creditor.kind === PayoutCreditorKind.BENEFICIARY
    ? creditor.description
    : resolvePurposeLabel(creditor, t);
}
